import { render, staticRenderFns } from "./seatsToSuitT&C.vue?vue&type=template&id=3db6924e&scoped=true&"
import script from "./seatsToSuitT&C.vue?vue&type=script&lang=js&"
export * from "./seatsToSuitT&C.vue?vue&type=script&lang=js&"
import style0 from "./seatsToSuitT&C.vue?vue&type=style&index=0&id=3db6924e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6924e",
  null
  
)

export default component.exports